import React, { useState } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { useUser } from '@lore/auth';
import Steps from './_common/Steps';
import usePageRouter from '@/dialogs-routable/_hooks/usePageRouter';
import Info from './Info';
import Confirmation from './Confirmation';
import ConfirmationRedirect from './ConfirmationRedirect';

export default function MatchingSupportWizard(props) {
  const { onCancel } = props;

  const currentUser = useUser();

  const { location } = usePageRouter();

  const [data, setData] = useState(() => {
    const inactiveSite = _.find(currentUser.data.sites, { isActive: false });
    const draftSite = _.find(currentUser.data.potentialSites, { reviewStatus: 'draft' });
    const more = inactiveSite ? `This site is already our database with with name ${inactiveSite.name}` : null;
    const site = inactiveSite ? inactiveSite : draftSite;

    return {
      name: site?.name,
      phone: currentUser.data.phoneNumber,
      website: site?.website,
      address: site?.addressLine1,
      city: site?.city,
      state: site?.state,
      zip: site?.zipCode,
      'num-learners': '',
      'free-reduced-lunch': '',
      'what-types-of-experience': '',
      more,
      potentialSiteId: site?.reviewStatus === 'draft' ? site?.id : null
    };
  });
  const [stepIndex, setStepIndex] = useState(Steps.INFO);

  function onNext(newData, newStepIndex) {
    setStepIndex(newStepIndex || (stepIndex + 1));
    setData(_.extend({}, data, newData));
  }

  const steps = [
    (props) => {
      return (
        <Info
          {...props}
          onNext={(newData) => onNext(newData, Steps.CONFIRMATION)}
          onCancel={onCancel}
        />
      );
    },
    (props) => {
      if (location.pathname.startsWith('/setup/school')) {
      return (
        <ConfirmationRedirect
          {...props}
          onCancel={onCancel}
        />
      );
      }

      return (
        <Confirmation
          {...props}
          onCancel={onCancel}
        />
      );
    }
  ];

  const step = steps[stepIndex]({
    user: currentUser,
    data: data
  });

  return (
    <div>
      {step}
    </div>
  );
}

MatchingSupportWizard.propTypes = {
  onCancel: PropTypes.func.isRequired
};
